import api from "apis/courses";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_PUT } from "tools/webservice";

export const addCourse = (course, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: course,
  endpoint: api.addCourse(),
  successCallback,
  mountedRef,
});

export const updateCourse = (course, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  payload: course,
  endpoint: api.updateCourse(),
  successCallback,
  mountedRef,
});

export const searchCourses = (searchTerm, showDisabled, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.searchCourses(searchTerm),
  successCallback: courses => successCallback(courses.filter(c => c.disabledDate === null || showDisabled)),
  mountedRef,
});

export const getCourseById = (id, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getCourseById(id),
  successCallback,
  mountedRef,
});
